import React, { useEffect, useRef, useState } from 'react';
import {
    Col,
    Form,
    Input,
    Row,
    Checkbox,
    Button,
    Select,
    Popover,
    message,
    Space,
    Spin,
    Switch,
} from 'antd';
import {
    RiSearch2Line,
    RiEdit2Fill,
    RiAddFill,
    RiArrowLeftLine,
    RiMore2Fill,
    RiBookOpenFill,
    RiTerminalBoxFill,
    RiFileList2Fill,
    RiEditLine,
    RiDeleteBinLine,
    RiLoader2Line,
} from 'react-icons/ri';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { RiCloseCircleLine } from 'react-icons/ri';
import { MdYoutubeSearchedFor } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import './EditForm.css';
import { useNavigate, useParams } from 'react-router-dom';
import { BuildQuickActionByIdActionHandler } from '../../../../Redux/Actions/user/BuildQuickActionDetailsById';
import {
    workspaces_List_ActionHandler,
    workspaces_List_Success,
} from '../../../../Redux/Actions/user/WorkspacesList';
import {
    get_User_Supporting_docsActionHandler,
    get_User_Supporting_docs_Success,
} from '../../../../Redux/Actions/user/GetUserSupportingDocs';
import {
    get_User_Output_Format_Success,
    get_User_Output_format_ActionHandler,
} from '../../../../Redux/Actions/user/GetUserOutputFormat';
import { build_Quick_Action_Action_UpdateHandler } from '../../../../Redux/Actions/user/BuildQuickActionUpdate';
import { workspaces_FolderList_ActionHandler } from '../../../../Redux/Actions/user/WorkspaceFolderList';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
//
import EditSupportDocument from '../EditSupportDocument/EditSupportDocument/EditSupportDocument';
import {
    workspaces_Support_Documents_Edit_Data_Details_ActionHandler,
    workspaces_Support_Documents_Edit_Data_List_Success,
} from '../../../../Redux/Actions/user/workspacesSupportDocumentsEditDataDetails';
import {
    workspaces_Support_Documents_Output_Edit_Data_Details_ActionHandler,
    workspaces_Support_Documents_Output_Edit_Data_List_Success,
} from '../../../../Redux/Actions/user/workspacesSupportDocumentsOutputEditDataDetails';
import EditWebsiteUrlSupportDocument from '../EditSupportDocument/EditWebsiteUrlSupportDocument/EditWebsiteUrlSupportDocument';
import EditOwnDataSupportDocument from '../EditSupportDocument/EditOwnDataSupportDocument/EditOwnDataSupportDocument';
import DeleteReferData from '../DeleteReferData/DeleteReferData';
import EditOwnDataSupportDocumentOutput from '../EditOutputFormat/EditOwnDataSupportDocumentOutput/EditOwnDataSupportDocumentOutput';
import EditSupportDocumentOutput from '../EditOutputFormat/EditSupportDocumentOutput/EditSupportDocumentOutput';
import DeleteOutputData from '../DeleteOutputData/DeleteOutputData';
import QuickSearchData from '../QuickSearchReferData/QuickSearchReferData';
import CreateSupportDocument from '../CreateSupportDocument/CreateSupportDocument';
import CreateOutputFormat from '../CreateOutputFormat/CreateOutputFormat';

import { Supporting_Document_Update_Success } from '../../../../Redux/Actions/user/SupportingDocumentsUpdate';
import { Supporting_Document_Output_Delete_Success } from '../../../../Redux/Actions/user/SupportingOutputDocumentsDelete';
import { Supporting_Document_Delete_Success } from '../../../../Redux/Actions/user/SupportingDocumentsDelete';
import {
    workspaces_SupportingDocumentsId_ActionHandler,
    workspaces_SupportingDocumentsId_Success,
} from '../../../../Redux/Actions/user/workspacesSupportingDocumentsId';
import {
    workspaces_OutputFormatsId_ActionHandler,
    workspaces_OutputFormatsId_Success,
} from '../../../../Redux/Actions/user/workspacesOutputFormatsId';
import Loader from '../../../../Components/Loader/Loader';
import { DocumentsSupportingCreateSuccess } from '../../../../Redux/Actions/user/BuildQuickCreateSupportingDocumentsAction';
import { DocumentsSupportingOutPutCreateSuccess } from '../../../../Redux/Actions/user/BuildQuickOutputCreateSupportingDocumentsAction';
import Swal from 'sweetalert2';
import { workspaces_Custome_List_ActionHandler } from '../../../../Redux/Actions/user/WorkspacesCustomList';
import Title from 'antd/es/typography/Title';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEdiorConfig } from '../../../../Config/CKEdiorConfig';
const prompt_icon = '/assets/Prompt.svg';
const basic_icon = '/assets/Basic_Info.svg';
const refrence_icon = '/assets/Reference.svg';
const destination_icon = '/assets/Destination.svg';

const { TextArea } = Input;
const { Option } = Select;
const lock_icon = '/assets/key-square.svg';
const EditForm = () => {
    const LockIcon = '/assets/lock.svg';
    const editorRef = useRef();
    const Navigate = useNavigate();
    const dispatch = useDispatch();
    const parms = useParams();
    const [form] = Form.useForm();
    const BuildActionId = parms?.id;
    const [isCreateSupportDocument, setIsCreateSupportDocument] =
        useState(false);
    const [isCreateOutputFormat, setIsCreateOutputFormat] = useState(false);
    const [isEditReferData, setIsEditReferData] = useState(false);
    const [isDeleteReferData, setIsDeleteReferData] = useState(false);
    const [isQuickSearchReferData, setIsQuickSearchReferData] = useState(false);
    const [workspaceId, setWorkspaceId] = useState('');
    const [workspaceFolderId, setworkspaceFolderId] = useState('');
    const [searchValueDoc, setSearchValueDoc] = useState(null);
    const [searchValueOutput, SetsearchValueOutput] = useState(null);
    const [getSupportingDocId, setgetSupportingDocId] = useState('');
    const [quickActionName, setQuickActionName] = useState('');
    const [descriptionData, setDescriptionData] = useState('');
    const [promptData, setPromptData] = useState('');
    const [supportDocsQuickSearchData, setSupportDocsQuickSearchData] =
        useState([]);
    const [spinningRecentlyUsed, setSpinningRecentlyUsed] = useState(false);
    const [supportingDocSendData, setSupportingDocSendData] = useState([]);
    const [outputFormatSendData, setOutputFormatSendData] = useState([]);
    const [ViewResult, setViewResult] = useState('');
    const [QuickrunSearch, setQuickrunSearch] = useState('');
    const [SupportingCheckboxId, setSupportingCheckboxId] = useState([]);
    const [supportingDocumentsData, setSupportingDocumentsData] = useState([]);
    const [dataWorkspaceId, setDataWorkspaceId] = useState('');
    const [currentSupportingPage, setCurrentSupportingPage] = useState(1);
    const [currentOutputPage, setCurrentOutputPage] = useState(1);
    const [OutputFormatApiData, setOutputFormatApiData] = useState([]);

    const [isUrlEditReferData, setIsUrlEditReferData] = useState(false);
    const [isFileType, setIsFileType] = useState(null);
    const [isTypeActions, setIsTypeActions] = useState(null);
    const [isOwnDataEditReferData, setIsOwnDataEditReferData] = useState(false);
    const [editSupportData, setEditSupportData] = useState([]);
    const [editOutputData, seteditOutputData] = useState([]);
    const [isEditOutputData, setIsEditOutputData] = useState(false);
    const [isEditOwnDataOutputData, setisEditOwnDataOutputData] =
        useState(false);
    const [isDeleteOutputData, setIsDeleteOutputData] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [accessLevelData, setAccessLevelData] = useState(false);
    const [SupportMainData, setSupportMainData] = useState([]);
    const [OutputMainData, setOutputMainData] = useState([]);

    const [supportDocumentIds, setSupportDocumentIds] = useState([]);
    const [OutputFormatIds, setOutputFormatIds] = useState([]);

    const [deleteOutputFormat, setDeleteOutPutFormet] = useState(false);
    const [creatingOnSpportFileCreate, setcreatingOnSpportFileCreate] =
        useState({});

    const [haveGotChecked, setHaveGotChecked] = useState([]);
    const [haveGotcheckedOutput, sethaveGotcheckedOutput] = useState([]);

    //drag and drop
    const [SupportingDocumentPromptText, setSupportingDocumentPromptText] =
        useState([]);
    const [outputFormatPromptText, setOutputFormatPromptText] = useState([]);

    const [handleAutoPrompt, setHandleAutoPrompt] = useState('');
    const [send_checkdocId, setSend_CheckdocId] = useState(false);
    ///
    const [description, setDescription] = useState('');
    const [sawEditor, setSawEditor] = useState(false);
    const [customeList, setCustomeList] = useState(null);
    const [customId, setCustomId] = useState(null);
    const [accessLevel, setAccessLevel] = useState(false);
    const [customChecked, setCustomChecked] = useState(false);
    const buildQuickActionEditData = useSelector(
        (state) =>
            state?.build_Quick_Action_By_Id_data?.build_quick_action_by_id__data
                ?.data
    );

    const userData = useSelector(
        (state) => state.SettingsUserProfileData.user_profile_data
    );

    const buildQuickActionEditDataLoader = useSelector(
        (state) => state?.build_Quick_Action_By_Id_data?.loader
    );

    const workspaceFolderListData = useSelector(
        (state) =>
            state?.workspaces_FolderList_Data?.workspace_folderList_data?.data
    );

    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const getUserSupportingDocData = useSelector(
        (state) =>
            state?.workspacesSupportingDocumentsIdData
                ?.workspace_supportingdocumentid_data
    );

    const getUserSupportingDocDataLoader = useSelector(
        (state) => state?.workspacesSupportingDocumentsIdData?.loader
    );

    const getUserOutputFormatData = useSelector(
        (state) =>
            state?.workspacesOutputFormatsIdData
                ?.workspace_output_formateid_data
    );

    const workspaceSupportDocumentsEditData = useSelector(
        (state) =>
            state?.WorkspaceSupportDocumentsEditData
                ?.workspace_support_documents_edit_data?.data
    );
    const workspaceSupportDocumentsOutputEditData = useSelector(
        (state) =>
            state?.WorkspaceSupportDocumentsOutputEditData
                ?.workspace_support_documents_output_edit_data?.data
    );
    const CustomListData = useSelector(
        (state) => state?.workspaces_CustomList_Data?.workspace_Custom_List_data
    );
    const supportinDocumentCreate = useSelector(
        (state) =>
            state?.BuildQuickCreateSupportingDocumentsData
                ?.documents_supporting_create_data
    );

    const OutputformatDocumentCreate = useSelector(
        (state) =>
            state?.BuildQuickOutputCreateSupportingDocumentsData
                ?.documents_supporting_output_create_data
    );

    const supportingdocumentdeleteData = useSelector(
        (state) =>
            state?.SupportingOutputDocumentDeletedata
                ?.Supporting_document_delete_data
    );

    const handleNextPageSupporting = () => {
        const totalItems = supportingDocumentsData?.length;
        const totalPages = Math.ceil(totalItems / 5);
        if (currentSupportingPage < totalPages) {
            setCurrentSupportingPage(currentSupportingPage + 1);
        }
    };

    const handlePrevPageSupporting = () => {
        if (currentSupportingPage > 1) {
            setCurrentSupportingPage(currentSupportingPage - 1);
        }
    };

    const handleNextPageOutput = () => {
        const totalItemsOutput = getUserOutputFormatData?.data?.data.length;
        const totalPagesOutput = Math.ceil(totalItemsOutput / 5);

        if (currentOutputPage < totalPagesOutput) {
            setCurrentOutputPage((prevPage) => prevPage + 1);
        }
    };

    const handlePrevPageOutput = () => {
        if (currentOutputPage > 1) {
            setCurrentOutputPage((prevPage) => prevPage - 1);
        }
    };

    useEffect(() => {
        if (currentSupportingPage) {
            const indexOfLastItemSupporting = currentSupportingPage * 5;
            const indexOfFirstItemSupporting = indexOfLastItemSupporting - 5;
            const currentItemsSupporting = supportingDocumentsData?.slice(
                indexOfFirstItemSupporting,
                indexOfLastItemSupporting
            );
            setSupportMainData([...currentItemsSupporting]);
        }
    }, [currentSupportingPage]);
    useEffect(() => {
        setCustomChecked(buildQuickActionEditData?.is_custom_qa);
        setCustomId(buildQuickActionEditData?.custom_qa_v_id);
        if (buildQuickActionEditData && getUserSupportingDocData?.data?.data) {
            const supportData = getUserSupportingDocData?.data?.data;
            for (let item of supportData) {
                let support = false;
                let findUnChecked = haveGotChecked?.find(
                    (hc) => hc === item?.id
                );
                if (!findUnChecked) {
                    support =
                        buildQuickActionEditData?.supporting_documents?.find(
                            (ba) => ba?.supporting_document_id === item?.id
                        );

                    if (support) {
                        const updatedIds = new Set([
                            support?.supporting_document_id,
                            ...supportDocumentIds,
                        ]);
                        setSupportDocumentIds([...updatedIds]);
                    } else if (!support) {
                        support = supportDocumentIds.find(
                            (sd) => sd === item?.id
                        );
                    }
                }

                item.isChecked = item.isChecked
                    ? item.isChecked
                    : support
                    ? true
                    : false;

                item.can_select = item.can_select ? item.can_select : false;

                item.is_qs = support?.is_qs ? support?.is_qs : false;
                item.rerun_on_data_update = support?.rerun_on_data_update
                    ? support?.rerun_on_data_update
                    : false;
                item.is_searched_now = support?.is_searched_now
                    ? support?.is_searched_now
                    : false;
            }

            supportData.sort((a, b) => {
                if (a.isChecked && !b.isChecked) {
                    return -1;
                } else if (!a.isChecked && b.isChecked) {
                    return 1;
                } else {
                    return 0;
                }
            });
            setSupportingDocumentsData([...supportData]);

            const indexOfLastItemSupporting = currentSupportingPage * 5;
            const indexOfFirstItemSupporting = indexOfLastItemSupporting - 5;
            const currentItemsSupporting = supportData?.slice(
                indexOfFirstItemSupporting,
                indexOfLastItemSupporting
            );
            setSupportMainData([...currentItemsSupporting]);

            const supportingDocumentArrays =
                buildQuickActionEditData?.supporting_documents.map(
                    (item) => item.supporting_document
                );
            const combinedSupportingDocuments = supportingDocumentArrays.flat();

            setSupportingDocumentPromptText(combinedSupportingDocuments);
        }
    }, [buildQuickActionEditData, getUserSupportingDocData?.data?.data]);

    useEffect(() => {
        if (currentOutputPage) {
            const indexOfLastItemOutput = currentOutputPage * 5;
            const indexOfFirstItemOutput = indexOfLastItemOutput - 5;
            const currentItemsOutput = OutputFormatApiData?.slice(
                indexOfFirstItemOutput,
                indexOfLastItemOutput
            );
            setOutputMainData(currentItemsOutput);
        }
    }, [currentOutputPage]);
    const handleChangeWorkspaceCustom = (value) => {
        setCustomId(value);
    };
    useEffect(() => {
        if (buildQuickActionEditData && getUserOutputFormatData?.data?.data) {
            let outputdata = getUserOutputFormatData?.data?.data;
            for (let item of outputdata) {
                let output = false;
                let findUnChecked = haveGotcheckedOutput?.find(
                    (hc) => hc === item?.id
                );
                if (!findUnChecked) {
                    output = buildQuickActionEditData?.output_formats?.find(
                        (ba) => ba?.output_format_id === item?.id
                    );

                    if (output) {
                        const updatedIds = new Set([
                            output?.output_format_id,
                            ...OutputFormatIds,
                        ]);
                        setOutputFormatIds([...updatedIds]);
                    } else if (!output) {
                        output = OutputFormatIds.find((sd) => sd === item?.id);
                    }
                }

                item.isChecked = item?.isChecked
                    ? item.isChecked
                    : output
                    ? true
                    : false;
            }
            outputdata.sort((a, b) => {
                if (a.isChecked && !b.isChecked) {
                    return -1;
                } else if (!a.isChecked && b.isChecked) {
                    return 1;
                } else {
                    return 0;
                }
            });
            setOutputFormatApiData([...outputdata]);

            const indexOfLastItemOutput = currentOutputPage * 5;
            const indexOfFirstItemOutput = indexOfLastItemOutput - 5;
            const currentItemsOutput = outputdata?.slice(
                indexOfFirstItemOutput,
                indexOfLastItemOutput
            );
            setOutputMainData([...currentItemsOutput]);

            const OutputFormatArrays =
                buildQuickActionEditData?.output_formats.map(
                    (item) => item.output_format
                );
            const combinedSupportingDocuments = OutputFormatArrays.flat();

            setOutputFormatPromptText(combinedSupportingDocuments);
        }
    }, [buildQuickActionEditData, getUserOutputFormatData?.data?.data]);

    useEffect(() => {
        const newInitialValues = {
            workspaceId: buildQuickActionEditData?.folder?.workspace_id,
            folder_id: buildQuickActionEditData?.folder_id,
            description: buildQuickActionEditData?.description,
            quickActionName: buildQuickActionEditData?.name,
            output_format_ids: '',
            prompt: buildQuickActionEditData?.prompt,
            supporting_documents: '',
        };

        form.setFieldsValue(newInitialValues);
        setQuickActionName(buildQuickActionEditData?.name || '');
        setWorkspaceId(buildQuickActionEditData?.folder?.workspace_id);
        setDescriptionData(buildQuickActionEditData?.description);
        setPromptData(buildQuickActionEditData?.prompt);
        setworkspaceFolderId(buildQuickActionEditData?.folder_id);
        setAccessLevelData(buildQuickActionEditData?.is_restricted);
        setAccessLevel(buildQuickActionEditData?.is_restricted);
        setAccessLevelData(buildQuickActionEditData?.is_restricted);
        if (buildQuickActionEditData?.is_restricted === true) {
            setSawEditor(true);
        } else {
            setSawEditor(false);
        }
        setDescription(buildQuickActionEditData?.description);
        setDataWorkspaceId(
            workspaceData?.find(
                (workspace) =>
                    workspace?.id ===
                    buildQuickActionEditData?.folder?.workspace_id
            )?.name
        );
    }, [buildQuickActionEditData, form]);

    useEffect(() => {
        dispatch(BuildQuickActionByIdActionHandler(BuildActionId));
        // eslint-disable-next-line
    }, [BuildActionId]);
    useEffect(() => {
        setCustomeList(CustomListData?.data);
    }, [CustomListData]);

    const handleChangeWorkspace = (value) => {
        setworkspaceFolderId(null);
        setWorkspaceId(value);
        setSupportingCheckboxId([]);
        setOutputFormatSendData([]);
        setworkspaceFolderId('');
    };
    const handleAccessLevelChange = (newValue) => {
        console.log('');
        setSawEditor(!sawEditor);
        setAccessLevel(newValue);
        setAccessLevelData(newValue);
    };
    const onChangeCkEditor = (event, editor) => {
        const data = editor.getData();
        setDescription(data);
    };

    const rows = 10;

    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));
        setIsCreateSupportDocument(false);
        dispatch(workspaces_Custome_List_ActionHandler());
        // Cleanup function
        return () => {
            dispatch(DocumentsSupportingCreateSuccess(null));
            dispatch(DocumentsSupportingOutPutCreateSuccess(null));
            dispatch(Supporting_Document_Update_Success(null));
            dispatch(Supporting_Document_Output_Delete_Success(null));
            dispatch(Supporting_Document_Delete_Success(null));
            setIsCreateSupportDocument(false);
            dispatch(workspaces_List_Success(null));
            dispatch(workspaces_Support_Documents_Edit_Data_List_Success(null));
            dispatch(workspaces_SupportingDocumentsId_Success(null));
            dispatch(workspaces_OutputFormatsId_Success(null));
            dispatch(
                workspaces_Support_Documents_Output_Edit_Data_List_Success(null)
            );
            dispatch(get_User_Supporting_docs_Success(null));
            dispatch(get_User_Output_Format_Success(null));
        };
    }, []);

    useEffect(() => {
        if (workspaceId) {
            dispatch(workspaces_FolderList_ActionHandler(workspaceId, '', ''));
        }
        // eslint-disable-next-line
    }, [workspaceId]);

    const handleButtonClick = () => {
        Navigate(-1);
    };

    const handleCreateSupportDocument = () => {
        setIsCreateSupportDocument(!isCreateSupportDocument);
    };

    const handleCreateOutputFormat = () => {
        setIsCreateOutputFormat(!isCreateOutputFormat);
    };
    const handleEditReferData = () => {
        setIsEditReferData(!isEditReferData);
    };
    const handleDeleteReferData = (Id, type) => {
        setPopoverVisible(false);
        if (Id) {
            setIsDeleteReferData(false);
            setIsTypeActions('Delete');
            dispatch(
                workspaces_Support_Documents_Edit_Data_Details_ActionHandler(Id)
            );
        }
        dispatch(get_User_Supporting_docsActionHandler(''));
    };

    const handleQuickSearchReferData = (id) => {
        setgetSupportingDocId(id);
        setIsQuickSearchReferData(!isQuickSearchReferData);
        setViewResult('');
        setPopoverVisible(false);
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSupportingDocsearch = debounce((e) => {
        let value = e.target.value.trim();
        if (value?.length) {
            setSearchValueDoc(value);
        }

        if (!value.length) {
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspaceId, '')
            );
        }
    }, 500);

    const handleOutputFormatsearch = debounce((e) => {
        let value = e.target.value.trim();
        if (value?.length) {
            SetsearchValueOutput(value);
        }

        if (!value?.length) {
            dispatch(workspaces_OutputFormatsId_ActionHandler(workspaceId, ''));
        }
    }, 500);

    useEffect(() => {
        if (searchValueDoc?.length > 1) {
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(
                    workspaceId,
                    searchValueDoc
                )
            );
        }
        // eslint-disable-next-line
    }, [searchValueDoc]);

    useEffect(() => {
        if (searchValueOutput?.length > 1) {
            dispatch(
                workspaces_OutputFormatsId_ActionHandler(
                    workspaceId,
                    searchValueOutput
                )
            );
        }
        // eslint-disable-next-line
    }, [searchValueOutput]);

    const handleCheckboxOutputChange = (itemId) => {
        const isChecked = outputFormatSendData?.includes(itemId);

        const updatedData = isChecked
            ? outputFormatSendData?.filter((id) => id !== itemId)
            : [...outputFormatSendData, itemId];

        setOutputFormatSendData(updatedData);
    };

    useEffect(() => {
        if (buildQuickActionEditData?.folder?.workspace_id) {
            setWorkspaceId(buildQuickActionEditData?.folder?.workspace_id);
        }
    }, [buildQuickActionEditData?.folder?.workspace_id]);

    useEffect(() => {
        if (workspaceId) {
            dispatch(workspaces_List_ActionHandler('', ''));

            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspaceId, '')
            );
            dispatch(workspaces_OutputFormatsId_ActionHandler(workspaceId, ''));
        }
    }, [workspaceId]);

    const handleQuickSubmit = () => {
        if (
            !quickActionName ||
            (!customChecked && !promptData) ||
            (accessLevel && !description) ||
            (customChecked && customId === null) ||
            !workspaceId ||
            !workspaceFolderId
        ) {
            message.error('Please fill in all required fields');
            return;
        }
        let outpuData = OutputFormatApiData?.filter((item) => item?.isChecked);
        let outputIds = [];

        for (let od of outpuData) {
            outputIds.push(od.id);
        }
        let request = {
            workspace_id: workspaceId,
            folder_id: workspaceFolderId,
            description: description || buildQuickActionEditData?.description,
            name: quickActionName || buildQuickActionEditData?.name,
            prompt: promptData || buildQuickActionEditData?.prompt,
            custom_qa_v_id: customChecked === true ? customId : null,
            is_restricted: accessLevelData,
            supporting_documents: supportingDocumentsData.filter(
                (item) => item?.isChecked
            ),
            output_format_ids: outputIds,
        };
        dispatch(
            build_Quick_Action_Action_UpdateHandler(
                request,
                BuildActionId,
                Navigate
            )
        );
    };

    useEffect(() => {
        if (workspaceSupportDocumentsEditData) {
            setEditSupportData(workspaceSupportDocumentsEditData);
            if (isTypeActions === 'Edit') {
                if (isFileType === 'file') {
                    setIsEditReferData(!isEditReferData);
                }
                if (isFileType === 'url') {
                    setIsUrlEditReferData(!isUrlEditReferData);
                }
                if (isFileType === 'text') {
                    setIsOwnDataEditReferData(!isOwnDataEditReferData);
                }
            } else if (isTypeActions === 'Delete') {
                setIsDeleteReferData(!isDeleteReferData);
            }
        }
    }, [workspaceSupportDocumentsEditData]);

    useEffect(() => {
        if (workspaceSupportDocumentsOutputEditData) {
            seteditOutputData(workspaceSupportDocumentsOutputEditData);
            if (isTypeActions === 'Edit') {
                if (isFileType === 'file') {
                    setIsEditOutputData(!isEditOutputData);
                }
                if (isFileType === 'text') {
                    setisEditOwnDataOutputData(!isEditOwnDataOutputData);
                }
            } else if (isTypeActions === 'Delete') {
                setIsDeleteOutputData(!isDeleteOutputData);
            }
        }
    }, [workspaceSupportDocumentsOutputEditData]);

    const handleEditClick = (Id, type) => {
        if (!isEditReferData) {
            setSpinningRecentlyUsed(true);
        } else {
            setSpinningRecentlyUsed(false);
        }
        setIsEditReferData(false);
        setIsUrlEditReferData(false);
        setIsOwnDataEditReferData(false);
        setIsTypeActions(null);
        setIsFileType(type);
        setPopoverVisible(false);
        if (Id && type) {
            setIsTypeActions('Edit');
            dispatch(
                workspaces_Support_Documents_Edit_Data_Details_ActionHandler(Id)
            );
        }
    };

    const handleEditOutputClick = (Id, type) => {
        if (!isEditOutputData) {
            setSpinningRecentlyUsed(true);
        } else {
            setSpinningRecentlyUsed(false);
        }
        setIsEditOutputData(false);
        setisEditOwnDataOutputData(false);
        setIsTypeActions(null);
        setIsFileType(type);
        if (Id && type) {
            setIsTypeActions('Edit');
            dispatch(
                workspaces_Support_Documents_Output_Edit_Data_Details_ActionHandler(
                    Id
                )
            );
        }
    };

    const handleDeleteReferDataButton = () => {
        setIsDeleteReferData(false);
        setSupportingDocumentsData([]);
    };

    const handleDeleteOutputData = (Id, type) => {
        setIsDeleteOutputData(false);
        if (Id) {
            setIsTypeActions('Delete');
            dispatch(
                workspaces_Support_Documents_Output_Edit_Data_Details_ActionHandler(
                    Id
                )
            );
        }
    };
    const handleDeleteOutputDataButton = () => {
        setIsDeleteOutputData(false);
        setOutputFormatApiData([]);
    };

    useEffect(() => {
        if (supportinDocumentCreate) {
            setSupportDocumentIds([
                supportinDocumentCreate?.data?.id,
                ...supportDocumentIds,
            ]);

            setcreatingOnSpportFileCreate(supportinDocumentCreate);
        }
    }, [supportinDocumentCreate]);

    useEffect(() => {
        if (getUserSupportingDocData?.data?.data?.length > 0 && workspaceId) {
            setTimeout(() => {
                const filteredData = getUserSupportingDocData?.data?.data?.find(
                    (item) => item.id === creatingOnSpportFileCreate?.data?.id
                );

                if (filteredData) {
                    if (!filteredData?.can_select) {
                        dispatch(
                            workspaces_SupportingDocumentsId_ActionHandler(
                                workspaceId,
                                ''
                            )
                        );
                    } else {
                        const index = SupportMainData?.findIndex(
                            (sd) => sd.id === filteredData.id
                        );
                        if (index !== -1) {
                            const updatedSupportMainData = [...SupportMainData];

                            updatedSupportMainData[index].isChecked = true;
                            updatedSupportMainData[index].can_select = true;
                            // setSupportMainData(updatedSupportMainData);
                        }
                    }
                }

                if (filteredData?.can_select) {
                    setTimeout(() => {
                        dispatch(DocumentsSupportingCreateSuccess(null));
                    }, 2500);
                }
            }, 3000);
        }
    }, [getUserSupportingDocData]);

    const OutputdocumentdeleteData = useSelector(
        (state) =>
            state?.SupportingOutputDocumentDeletedata
                ?.Supporting_document_delete_data
    );

    useEffect(() => {
        if (
            (supportinDocumentCreate ||
                OutputformatDocumentCreate ||
                supportingdocumentdeleteData ||
                OutputdocumentdeleteData) &&
            workspaceId
        ) {
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspaceId, '')
            );
            dispatch(workspaces_OutputFormatsId_ActionHandler(workspaceId, ''));
        }
    }, [
        supportinDocumentCreate?.data,
        OutputformatDocumentCreate?.data,
        supportingdocumentdeleteData,
        OutputdocumentdeleteData,
    ]);

    ///drag drop create support
    useEffect(() => {
        const filteredData = getUserSupportingDocData?.data?.data?.find(
            (item) => item.id === creatingOnSpportFileCreate?.data?.id
        );
        if (filteredData?.can_select && SupportMainData[0]?.can_select) {
            if (
                !SupportingDocumentPromptText?.some(
                    (documentName) => documentName?.name === filteredData?.name
                )
            ) {
                setSupportingDocumentPromptText((prevState) => [
                    ...prevState,
                    filteredData,
                ]);
            }
        }
    }, [SupportMainData]);

    ///drag drop create output
    // useEffect(() => {
    //   const filteredData = getUserSupportingDocData?.data?.data?.find(
    //     (item) => item.id === creatingOnSpportFileCreate?.data?.id
    //   );
    //   if (filteredData?.can_select && OutputMainData[0]?.can_select) {
    //     if (
    //       !SupportingDocumentPromptText?.some(
    //         (documentName) => documentName?.name === filteredData?.name
    //       )
    //     ) {
    //       setSupportingDocumentPromptText((prevState) => [
    //         ...prevState,
    //         filteredData,
    //       ]);
    //     }
    //   }
    // }, [SupportMainData]);

    /////

    const doSupportingChecked = (index, itemId) => {
        const updatedSupportMainData = [...SupportMainData];

        if (updatedSupportMainData[index].isChecked) {
            setHaveGotChecked([
                updatedSupportMainData[index].id,
                ...haveGotChecked,
            ]);
        } else {
            let unchecked = [...haveGotChecked];
            let findIndex = unchecked.findIndex(
                (hc) => hc === updatedSupportMainData[index].id
            );
            if (findIndex !== -1) {
                unchecked?.splice(findIndex, 1);
                setHaveGotChecked(unchecked);
            }
        }

        updatedSupportMainData[index].isChecked =
            !updatedSupportMainData[index].isChecked;

        setSupportMainData(updatedSupportMainData);

        // drag
    };

    useEffect(() => {
        if (OutputformatDocumentCreate) {
            setOutputFormatIds([
                OutputformatDocumentCreate?.data?.id,
                ...OutputFormatIds,
            ]);
        }
    }, [OutputformatDocumentCreate]);

    useEffect(() => {
        if (
            OutputformatDocumentCreate?.data?.id &&
            OutputMainData?.length > 0
        ) {
            const index = OutputMainData?.findIndex(
                (item) => item.id === OutputformatDocumentCreate?.data?.id
            );
            if (index !== -1) {
                const updatedOutputMainData = [...OutputMainData];
                updatedOutputMainData[index].isChecked = true;
                setOutputMainData(updatedOutputMainData);
            }

            setTimeout(() => {
                dispatch(DocumentsSupportingOutPutCreateSuccess(null));
            }, 2500);

            //create output drag and drop

            if (
                OutputformatDocumentCreate?.data?.id &&
                OutputMainData[0]?.isChecked
            ) {
                if (
                    !outputFormatPromptText?.some(
                        (documentName) =>
                            documentName?.name ===
                            OutputformatDocumentCreate?.data?.name
                    )
                ) {
                    setOutputFormatPromptText((prevState) => [
                        ...prevState,
                        OutputformatDocumentCreate?.data,
                    ]);
                }
            }
        }
    }, [OutputformatDocumentCreate?.data?.id, OutputMainData]);

    const doOutputChecked = (index, itemId) => {
        const updatedOutputMainData = [...OutputMainData];

        if (updatedOutputMainData[index].isChecked) {
            sethaveGotcheckedOutput([
                updatedOutputMainData[index].id,
                ...haveGotcheckedOutput,
            ]);
        } else {
            let unchecked = [...haveGotcheckedOutput];
            let findIndex = unchecked?.findIndex(
                (hc) => hc === updatedOutputMainData[index].id
            );
            if (findIndex !== -1) {
                unchecked.splice(findIndex, 1);
                sethaveGotcheckedOutput(unchecked);
            }
        }

        updatedOutputMainData[index].isChecked =
            !updatedOutputMainData[index].isChecked;

        setOutputMainData(updatedOutputMainData);

        // drag
    };

    useEffect(() => {
        if (supportDocsQuickSearchData && SupportMainData) {
            const newData = {
                is_qs: supportDocsQuickSearchData?.score ? true : false,
                relevance_score: supportDocsQuickSearchData?.score || null,
                search_type: QuickrunSearch ? 'context' : null,
                search_query: QuickrunSearch || null,
                search_result: supportDocsQuickSearchData.search_result || null,
            };

            const index = SupportMainData.findIndex(
                (item) => item.id === getSupportingDocId
            );

            if (index !== -1) {
                setSupportMainData((prevData) => {
                    const updatedData = [...prevData];
                    updatedData[index] = { ...updatedData[index], ...newData };
                    return updatedData;
                });
            }
        }
    }, [supportDocsQuickSearchData]);

    useEffect(() => {
        if (deleteOutputFormat && workspaceId) {
            setTimeout(() => {
                dispatch(
                    workspaces_OutputFormatsId_ActionHandler(workspaceId, '')
                );
                setDeleteOutPutFormet(false);
            }, 2500);
        }
    }, [deleteOutputFormat]);

    const handleCustomChange = (newValue) => {
        setCustomId(null);
        setCustomChecked(newValue);
    };

    const handleSelect = (value) => {
        setworkspaceFolderId(value);
    };

    const handleChange = (value) => {
        setworkspaceFolderId(value);
    };
    return (
        <>
            <div>
                {buildQuickActionEditDataLoader && <Loader />}
                <Form form={form}>
                    <div className='from-container'>
                        <div className='from-main_1'>
                            <div className='from-build-main'>
                                <h2>Edit Build QuickAction</h2>
                                <p
                                    className='form-p form-w from-pointer form-flex form-justify-content form-align-items'
                                    onClick={handleButtonClick}>
                                    <RiArrowLeftLine /> Back
                                </p>
                            </div>
                            <p className='mt-0'>
                                Craft your QuickAction manually by filling out
                                below details
                            </p>

                            <div className='from-basic-main'>
                                {/* <RiEdit2Fill className='form-sideIcon-size' /> */}
                                <img
                                    src={basic_icon}
                                    className='form-sideIcon-size mt-0 mt-3'
                                />
                                <p className='form-p form-w form-ml-5'>
                                    {' '}
                                    Basic Information
                                </p>
                            </div>
                            <p className='form-label'>QuickAction Name</p>
                            <div className='form-search-div'>
                                <Form.Item
                                    name='quickActionName'
                                    initialValue={quickActionName}
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please input your QuickAction Name!',
                                        },
                                    ]}>
                                    <Input
                                        placeholder='Enter your QuickAction Name'
                                        onChange={(e) =>
                                            setQuickActionName(e.target.value)
                                        }
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div>
                            <div className='form-main-sub-title'>
                                {/* <RiFileList2Fill className='form-sideIcon-size' /> */}
                                <img
                                    src={destination_icon}
                                    className='form-sideIcon-size mt-0 mt-3'
                                />
                                <p className='form-p form-w form-ml-5 mt-0'>
                                    Select Destination Workspace
                                </p>
                            </div>
                            <div className=''>
                                <Row gutter={24}>
                                    <Col span={12}>
                                        <label className='form-label'>
                                            Select Workspace
                                        </label>
                                        <div className='form-search-div'>
                                            <Form.Item
                                                name='workspaceId'
                                                initialValue={dataWorkspaceId}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            'Please select a workspace!',
                                                    },
                                                ]}>
                                                <Select
                                                    className='uploadcomputer-select mt-0'
                                                    onChange={
                                                        handleChangeWorkspace
                                                    }>
                                                    {workspaceData &&
                                                        workspaceData
                                                            ?.filter(
                                                                (workspace) =>
                                                                    !workspace.is_locked
                                                            )
                                                            ?.map(
                                                                (workspace) => (
                                                                    <Option
                                                                        key={
                                                                            workspace?.id
                                                                        }
                                                                        value={
                                                                            workspace?.id
                                                                        }>
                                                                        {
                                                                            workspace?.name
                                                                        }
                                                                    </Option>
                                                                )
                                                            )}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className='own-data-2 mt-0'>
                                            <label className='form-label'>
                                                Select Folder
                                            </label>
                                            <div className='form-search-div'>
                                                <Form.Item
                                                    name='folder_id'
                                                    initialValue={
                                                        workspaceFolderId
                                                    }
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                'Please select a folder!',
                                                        },
                                                    ]}>
                                                    <div>
                                                        <Select
                                                            className='uploadcomputer-select mt-0'
                                                            name='folder_id'
                                                            placeholder='Select Folder'
                                                            onSelect={
                                                                handleSelect
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            value={
                                                                workspaceFolderId
                                                            }>
                                                            {workspaceFolderListData &&
                                                                workspaceFolderListData?.map(
                                                                    (
                                                                        folder
                                                                    ) => (
                                                                        <Option
                                                                            key={
                                                                                folder?.id
                                                                            }
                                                                            value={
                                                                                folder?.id
                                                                            }>
                                                                            {
                                                                                folder?.name
                                                                            }
                                                                        </Option>
                                                                    )
                                                                )}
                                                        </Select>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className='own-data-2'>
                            <label className='form-label'>Select Folder</label>
                            <Form.Item
                                name='folder_id'
                                initialValue={workspaceFolderId}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a folder!',
                                    },
                                ]}>
                                <div>
                                    <Select
                                        className='uploadcomputer-select'
                                        name='folder_id'
                                        // onChange={(value) =>
                                        //     setworkspaceFolderId(value)
                                        // }
                                        value={workspaceFolderId}
                                        onSelect={handleSelect}
                                        onChange={handleChange}>
                                        {workspaceFolderListData &&
                                            workspaceFolderListData?.map(
                                                (folder) => (
                                                    <Option
                                                        key={folder?.id}
                                                        value={folder?.id}>
                                                        {folder?.name}
                                                    </Option>
                                                )
                                            )}
                                    </Select>
                                </div>
                            </Form.Item>
                        </div>
                        <div className='form-main-sub-title'>
                            <img src={LockIcon} alt='' className='lock-icon' />
                            <p className='form-p form-w form-ml-5'>
                                Access Control
                            </p>
                        </div>
                        <Form.Item name='access-control'>
                            <Title level={5}>
                                Restricted &nbsp;&nbsp;&nbsp;
                                <Switch
                                    name='is_restricted'
                                    size='large'
                                    className='switch-large'
                                    checked={accessLevel}
                                    onChange={handleAccessLevelChange}
                                />
                            </Title>
                            <p>
                                Enabling this option hides the prompts and
                                reference data
                            </p>
                        </Form.Item>
                        {sawEditor && (
                            <div>
                                <Title className='mt-0' level={5}>
                                    Description
                                </Title>
                                <CKEditor
                                    editor={ClassicEditor}
                                    // onBlur={() => setAnswerTouched(true)}
                                    placeholder='Provide a description including the purpose and instructions of this QuickAction.'
                                    onChange={(event, editor) =>
                                        onChangeCkEditor(event, editor)
                                    }
                                    style={{ height: `${rows * 25}px` }}
                                    value={description}
                                    ref={editorRef}
                                    data={description || ''}
                                    config={{
                                        toolbar: CKEdiorConfig,
                                        placeholder:
                                            'Provide a description including the purpose and instructions of this QuickAction.',
                                    }}
                                />
                            </div>
                        )}
                        {/* //////////////////////////// */}
                        <div className='custom-quickaction'>
                            {userData.client_id === 1 && (
                                <Row
                                    className='custom-bg'
                                    justify='space-between'
                                    align='middle'>
                                    <Col span={20}>
                                        <h3 className='mb-0 font-unset'>
                                            Enable Custom QuickAction
                                        </h3>
                                        <p>
                                            As a Super Admin, you can build a
                                            Custom QuickAction by selecting from
                                            a range of tailored solutions
                                        </p>
                                    </Col>
                                    <Col span={4} className='text-right'>
                                        <Switch
                                            size='large'
                                            className='switch-large'
                                            // defaultChecked={customChecked}
                                            checked={customChecked}
                                            onChange={handleCustomChange}
                                        />
                                    </Col>
                                </Row>
                            )}
                            <div className='padding'>
                                {!customChecked ? (
                                    <>
                                        <div className='from-refer-data'>
                                            {/* <RiFileList2Fill className="form-sideIcon-size mt-0 mt-3" /> */}
                                            <img
                                                src={refrence_icon}
                                                className='form-sideIcon-size mt-0 mt-3'
                                            />
                                            <p className='form-p form-w form-ml-5 mt-0'>
                                                Reference data
                                            </p>
                                        </div>
                                        <div className='from-main_2'>
                                            <div className='from-tabel'>
                                                <Row>
                                                    <Col span={24}>
                                                        <div>
                                                            <p className='form-p form-w'>
                                                                Supporting
                                                                Documents
                                                            </p>
                                                            <p className='form-label'>
                                                                This data will
                                                                support and
                                                                inform the
                                                                output of your
                                                                QuickAction.
                                                            </p>
                                                        </div>
                                                    </Col>
                                                    <Col span={24}>
                                                        <div
                                                            className='form-svg-text from-pointer'
                                                            onClick={
                                                                handleCreateSupportDocument
                                                            }>
                                                            <div className='form-flex'>
                                                                <div className='form-text'>
                                                                    Create New
                                                                    Document
                                                                </div>
                                                                <div className='form-text'>
                                                                    <RiAddFill className='form-sideIcon-size' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col span={24}>
                                                        <div className=' build-form'>
                                                            <input
                                                                created_by='text'
                                                                placeholder='Browse from Library'
                                                                onChange={
                                                                    handleSupportingDocsearch
                                                                }
                                                            />
                                                            <RiSearch2Line className='build-form-image' />
                                                        </div>
                                                    </Col>

                                                    <Col
                                                        span={24}
                                                        className='doc-forwarding'>
                                                        <p className='form-p'>
                                                            Uploaded Documents
                                                        </p>
                                                        <div>
                                                            <FaChevronLeft
                                                                onClick={
                                                                    handlePrevPageSupporting
                                                                }
                                                            />
                                                            <FaChevronRight
                                                                onClick={
                                                                    handleNextPageSupporting
                                                                }
                                                            />
                                                        </div>
                                                    </Col>

                                                    {SupportMainData &&
                                                        SupportMainData?.map(
                                                            (item, index) => (
                                                                <Col
                                                                    span={24}
                                                                    key={index}>
                                                                    <div className='form-upload-document'>
                                                                        <div className='form-flex'>
                                                                            <div className='form-upload-document-svg '>
                                                                                <RiBookOpenFill className='form-sideIcon-size' />{' '}
                                                                                <div>
                                                                                    {
                                                                                        item?.name
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className='form-flex-checkbox'>
                                                                                {item?.can_select ? (
                                                                                    <Checkbox
                                                                                        className='form-custom-checkbox'
                                                                                        checked={
                                                                                            item?.isChecked
                                                                                        }
                                                                                        onChange={() => {
                                                                                            setgetSupportingDocId(
                                                                                                item?.id
                                                                                            );
                                                                                            doSupportingChecked(
                                                                                                index,
                                                                                                item?.id
                                                                                            );
                                                                                        }}></Checkbox>
                                                                                ) : (
                                                                                    <div className='loader-form'>
                                                                                        <RiLoader2Line className='loader-icon-form' />
                                                                                    </div>
                                                                                )}
                                                                                <Popover
                                                                                    content={
                                                                                        <div>
                                                                                            <div
                                                                                                className='popover-content-form'
                                                                                                onClick={() => {
                                                                                                    handleQuickSearchReferData(
                                                                                                        item?.id
                                                                                                    );
                                                                                                }}>
                                                                                                <MdYoutubeSearchedFor />
                                                                                                Quick
                                                                                                Search
                                                                                            </div>
                                                                                            <div
                                                                                                className='popover-content-form'
                                                                                                onClick={() =>
                                                                                                    handleEditClick(
                                                                                                        item?.id,
                                                                                                        item?.type
                                                                                                    )
                                                                                                }>
                                                                                                <RiEditLine />
                                                                                                Edit
                                                                                            </div>
                                                                                            <div
                                                                                                className='popover-content-form'
                                                                                                onClick={() =>
                                                                                                    handleDeleteReferData(
                                                                                                        item?.id,
                                                                                                        item?.type
                                                                                                    )
                                                                                                }>
                                                                                                <RiDeleteBinLine />
                                                                                                Delete
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                    // trigger="click"
                                                                                >
                                                                                    <RiMore2Fill className='form-sideIcon-size form-ml-10' />
                                                                                </Popover>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            )
                                                        )}
                                                </Row>
                                            </div>
                                            <div className='from-availibility'>
                                                <div className='from-aval-inner'>
                                                    <Row>
                                                        <Col span={24}>
                                                            <div>
                                                                <p className='form-p form-w'>
                                                                    Output
                                                                    Format
                                                                </p>
                                                                <p className='form-label'>
                                                                    This
                                                                    represents
                                                                    your desired
                                                                    output
                                                                    format,
                                                                    ensuring
                                                                    output
                                                                    consistency.
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div
                                                                className='form-svg-text from-pointer'
                                                                onClick={
                                                                    handleCreateOutputFormat
                                                                }>
                                                                <div className='form-flex'>
                                                                    <div className='form-text'>
                                                                        Create
                                                                        Output
                                                                        Format
                                                                    </div>
                                                                    <div className='form-text'>
                                                                        <RiAddFill className='form-sideIcon-size' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className='build-form'>
                                                                <input
                                                                    created_by='text'
                                                                    placeholder='Browse from Library'
                                                                    onChange={
                                                                        handleOutputFormatsearch
                                                                    }
                                                                />
                                                                <RiSearch2Line className='build-form-image' />
                                                            </div>
                                                        </Col>

                                                        <Col
                                                            span={24}
                                                            className='doc-forwarding'>
                                                            <p className='form-p'>
                                                                Uploaded
                                                                Documents
                                                            </p>
                                                            <div>
                                                                <FaChevronLeft
                                                                    onClick={
                                                                        handlePrevPageOutput
                                                                    }
                                                                />
                                                                <FaChevronRight
                                                                    onClick={
                                                                        handleNextPageOutput
                                                                    }
                                                                />
                                                            </div>
                                                        </Col>
                                                        {OutputMainData &&
                                                            OutputMainData?.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => (
                                                                    <Col
                                                                        span={
                                                                            24
                                                                        }
                                                                        key={
                                                                            index
                                                                        }>
                                                                        <div className='form-upload-document'>
                                                                            <div className='form-flex'>
                                                                                <div className='form-upload-document-svg'>
                                                                                    <RiBookOpenFill className='form-sideIcon-size' />{' '}
                                                                                    <span>
                                                                                        {' '}
                                                                                        {
                                                                                            item?.name
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                                <div className='form-flex-checkbox'>
                                                                                    <Checkbox
                                                                                        className='form-custom-checkbox'
                                                                                        value='A'
                                                                                        checked={
                                                                                            item?.isChecked
                                                                                        }
                                                                                        onChange={() => {
                                                                                            doOutputChecked(
                                                                                                index,
                                                                                                item?.id
                                                                                            );
                                                                                            handleCheckboxOutputChange(
                                                                                                item?.id
                                                                                            );
                                                                                        }}></Checkbox>
                                                                                    <Popover
                                                                                        content={
                                                                                            <div>
                                                                                                <div
                                                                                                    className='popover-content-form'
                                                                                                    onClick={() => {
                                                                                                        handleQuickSearchReferData(
                                                                                                            item?.id
                                                                                                        );
                                                                                                    }}>
                                                                                                    <MdYoutubeSearchedFor />
                                                                                                    Quick
                                                                                                    Search
                                                                                                </div>
                                                                                                <div
                                                                                                    className='popover-content-form'
                                                                                                    onClick={() =>
                                                                                                        handleEditOutputClick(
                                                                                                            item?.id,
                                                                                                            item?.type
                                                                                                        )
                                                                                                    }>
                                                                                                    <RiEditLine />
                                                                                                    Edit
                                                                                                </div>
                                                                                                <div
                                                                                                    className='popover-content-form'
                                                                                                    onClick={() =>
                                                                                                        handleDeleteOutputData(
                                                                                                            item?.id,
                                                                                                            item?.type
                                                                                                        )
                                                                                                    }>
                                                                                                    <RiDeleteBinLine />
                                                                                                    Delete
                                                                                                </div>
                                                                                            </div>
                                                                                        }
                                                                                        // trigger="click"
                                                                                    >
                                                                                        <RiMore2Fill className='form-sideIcon-size form-ml-10' />
                                                                                    </Popover>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                )
                                                            )}
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-mb-24'>
                                            <div className='from-main_1'>
                                                <div className='form-main-sub-title'>
                                                    {/* <RiTerminalBoxFill className="form-sideIcon-size mt-3" /> */}
                                                    <img
                                                        src={prompt_icon}
                                                        className='form-sideIcon-size mt-0 mt-3'
                                                    />
                                                    <p className='form-p form-w form-ml-5 mt-0'>
                                                        QuickAction Prompt
                                                    </p>
                                                </div>
                                                <div className=''>
                                                    <p className='form-label mt-0'>
                                                        Compose your QuickAction
                                                        here.
                                                    </p>
                                                    <Form.Item
                                                        name='prompt'
                                                        initialValue={prompt}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    'Please input your QuickAction Name!',
                                                            },
                                                        ]}>
                                                        <TextArea
                                                            rows='4'
                                                            value={promptData}
                                                            className='mt-5'
                                                            placeholder='Write your prompt...'
                                                            onChange={(e) =>
                                                                setPromptData(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className='form-mb-24'>
                                        <div className='from-main_1'>
                                            <div className=''>
                                                <h5 className='form-label label-img mt-3'>
                                                    <img
                                                        src={lock_icon}
                                                        className=''
                                                    />
                                                    &nbsp;&nbsp;Select Custom
                                                    QuickAction
                                                </h5>
                                                <div className=''>
                                                    <Form.Item
                                                        name='custom_id'
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    'Please select a workspace!',
                                                            },
                                                        ]}>
                                                        <Select
                                                            className=''
                                                            defaultValue={
                                                                customId
                                                            }
                                                            showSearch
                                                            optionFilterProp='children'
                                                            filterOption={(
                                                                input,
                                                                option
                                                            ) =>
                                                                option.children
                                                                    .toLowerCase()
                                                                    .indexOf(
                                                                        input.toLowerCase()
                                                                    ) >= 0
                                                            }
                                                            onChange={
                                                                handleChangeWorkspaceCustom
                                                            }>
                                                            {customeList &&
                                                                customeList?.map(
                                                                    (data) => (
                                                                        <Option
                                                                            key={
                                                                                data?.id
                                                                            }
                                                                            value={
                                                                                data?.id
                                                                            }>
                                                                            {
                                                                                data?.name
                                                                            }
                                                                        </Option>
                                                                    )
                                                                )}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='form-action-button'>
                            <Button
                                className='main-form-button'
                                onClick={handleQuickSubmit}>
                                Save
                            </Button>
                        </div>
                    </div>
                </Form>
                {/* </Spin> */}
            </div>
            {/* Loader Start */}

            {isEditReferData ? (
                <EditSupportDocument
                    isEditReferData={isEditReferData}
                    handleEditClick={handleEditClick}
                    editSupportData={editSupportData}
                    workspaceFolderFlag={false}
                    workspace_id={workspaceId}
                    folder_id={buildQuickActionEditData?.folder_id}
                />
            ) : null}
            {isUrlEditReferData ? (
                <EditWebsiteUrlSupportDocument
                    isUrlEditReferData={isUrlEditReferData}
                    handleEditClick={handleEditClick}
                    editSupportData={editSupportData}
                    workspaceFolderFlag={false}
                />
            ) : null}
            {isOwnDataEditReferData ? (
                <EditOwnDataSupportDocument
                    isOwnDataEditReferData={isOwnDataEditReferData}
                    handleEditClick={handleEditClick}
                    editSupportData={editSupportData}
                    workspaceFolderFlag={false}
                    workspace_id={workspaceId}
                />
            ) : null}
            {isDeleteReferData ? (
                <DeleteReferData
                    isDeleteReferData={isDeleteReferData}
                    handleDeleteReferData={handleDeleteReferData}
                    editSupportData={editSupportData}
                    handleDeleteReferDataButton={handleDeleteReferDataButton}
                />
            ) : null}
            {isEditOwnDataOutputData ? (
                <EditOwnDataSupportDocumentOutput
                    isEditOwnDataOutputData={isEditOwnDataOutputData}
                    handleEditClick={handleEditOutputClick}
                    editOutputData={editOutputData}
                    workspaceFolderFlag={false}
                    workspace_id={workspaceId}
                />
            ) : null}
            {isEditOutputData ? (
                <EditSupportDocumentOutput
                    isEditOutputData={isEditOutputData}
                    handleEditClick={handleEditOutputClick}
                    editOutputData={editOutputData}
                    workspaceFolderFlag={false}
                    workspace_id={workspaceId}
                />
            ) : null}
            {isDeleteOutputData ? (
                <DeleteOutputData
                    isDeleteOutputData={isDeleteOutputData}
                    handleDeleteOutputData={handleDeleteOutputData}
                    editOutputData={editOutputData}
                    handleDeleteOutputDataButton={handleDeleteOutputDataButton}
                    setDeleteOutPutFormet={setDeleteOutPutFormet}
                />
            ) : null}
            {isQuickSearchReferData ? (
                <QuickSearchData
                    isQuickSearchReferData={isQuickSearchReferData}
                    getSupportingDocId={getSupportingDocId}
                    handleQuickSearchReferData={handleQuickSearchReferData}
                    setSupportDocsQuickSearchData={
                        setSupportDocsQuickSearchData
                    }
                    setViewResult={setViewResult}
                    ViewResult={ViewResult}
                    setQuickrunSearch={setQuickrunSearch}
                />
            ) : null}

            {isCreateSupportDocument ? (
                <CreateSupportDocument
                    isCreateSupportDocument={isCreateSupportDocument}
                    handleCreateSupportDocument={handleCreateSupportDocument}
                    workspaceFolderFlag={false}
                    workspaceId={workspaceId}
                />
            ) : null}
            {isCreateOutputFormat ? (
                <CreateOutputFormat
                    isCreateOutputFormat={isCreateOutputFormat}
                    handleCreateOutputFormat={handleCreateOutputFormat}
                    workspaceId={workspaceId}
                />
            ) : null}
        </>
    );
};

export default EditForm;
